import Signin from "../modules/Auth/Signin";
import Dashboard from "../pages/Dashboard/Dashboard.jsx";
import ForgotPassword from "../modules/Auth/ForgotPassword.jsx";
import EnterSecurityCode from "../modules/Auth/EnterSecurityCode";
import NewPassword from "../modules/Auth/NewPassword";
import EventDetails from "../pages/EventDetails/EventDetails";
// import PurchasedEventDetails from '../pages/EventDetails/PurchasedEventDetails.jsx'
import EditProfilePage from "../pages/Profile/EditProfile/Index.jsx";
import PaymentDetails from "../pages/Profile/PaymentDetails.jsx";
import TransactionsList from "../pages/Profile/Transactions.jsx";
import ChangePassword from "../pages/Profile/ChangePassword.jsx";
import HelpandSupport from "../pages/Profile/HelpandSupport.jsx";
import CreateEvent from "../pages/Dashboard/CreateEvent/Index.jsx";
import EditEventFrom from "../pages/Dashboard/CreateEvent/EditEventFrom.jsx";
import EditGenderIdentity from "../pages/Profile/EditProfile/EditGenderIdentity.jsx";
import EditEthnicity from "../pages/Profile/EditProfile/EditEthnicity.jsx";
import EditGoals from "../pages/Profile/EditProfile/EditGoals.jsx";
import EditLGBTQDetails from "../pages/Profile/EditProfile/EditLGBTQDetails.jsx";
import EditDisabilityStatus from "../pages/Profile/EditProfile/EditDisabilityStatus.jsx";
import EditSubscription from "../pages/Profile/EditProfile/EditSubscription.jsx";
import EditLocationSponsor from "../pages/Profile/EditProfile/EditLocationSponsor.jsx";
import EditLanguageSpoken from "../pages/Profile/EditProfile/EditLanguagesSpoken.jsx";
import EditEmploymentStatus from "../pages/Profile/EditProfile/EditEmploymentStatus.jsx";
import ViewPdf from "../pages/Dashboard/CreateEvent/ViewPdf.jsx";
import EditContentRetention from "../pages/Profile/EditContentRetention.jsx";
import ManageContentRetention from "../pages/Profile/ManageContentRetention.jsx";
import PreviewPdf from "../pages/EventDetails/PreviewPdf.jsx";
import ScormPlayer from "../pages/Scorm/ScormPlayer.jsx";
import { SCORM_ENABLED } from "../helpers/scorm/featureFlag";
import { CAPABILITIES } from "../features/capabilities/contract";
import RequireProfileLoaded from "../pages/Profile/EditProfile/RequireProfileLoaded.jsx";
import { profileSectionRequirements } from "../pages/Profile/EditProfile/profileSections";

const PathAuth = {
  ChangePassword: "/change-password",
  ForgotPassword: "/forgot-password",
  Signin: "/login",
  Signup: "/register",
  VerifyCode: "/verify-code",
  NewPassword: "/new-password",
};

const PathDashboard = {
  Dashboard: "/dashboard",
  EventDetails: "dashboard/details/:id",
  //PurchasedEventDetails: '/dashboard/purchased/details/:id',
  CreateEvent: "/events/create-event",
  ViewPdf: "/events/view-pdf",
  PreviewPdf: "/event-details/view-pdf",
  EditEvent: "/events/edit-event/:id",
  ScormPlayer: "/scorm/player/:courseId",
};
const PathProfile = {
  EditProfile: "/profile/edit-profile",
  EditSubscription: "/profile/edit-subscription",
  EditGenderIdentity: "/profile/edit-gender-identity",
  EditEthnicity: "/profile/edit-ethnicity",
  EditGoals: "/profile/edit-goals",
  EditLGBTQDetails: "/profile/edit-lgbtq-details",
  EditDisabilityStatus: "/profile/edit-disability-status",
  EditLanguageSpoken: "/profile/edit-languages-spoken",
  EditEmploymentStatus: "/profile/edit-employment-status",
  EditLocationSponsor: "/profile/edit-location-sponsor",
  PaymentDetails: "/profile/payment-details",
  Transactions: "/profile/transactions",
  ContentRetention: "/profile/content-retention",
  ManageContentRetention: "/profile/manage-content-retention",
  ChangePassword: "/profile/change-password",
  HelpSupport: "/profile/help-support",
};

const Path = {
  Root: "/",
  ...PathAuth,
  ...PathDashboard,
  ...PathProfile,
  Terms: "/terms",
  Community: "/community-guidelines",
  PrivacyPolicy: "/privacy",
  DeleteAccount: "/delete-account",
};

const ProtectedRoutes = [
  {
    element: <Dashboard />,
    requiredCapability: CAPABILITIES.platformAccess,
    path: Path.Dashboard,
    name: "Dashboard",
  },
  {
    element: <EventDetails />,
    usesStripe: true,
    requiredCapability: CAPABILITIES.platformAccess,
    path: Path.EventDetails,
    name: "Dashboard Details",
  },
  // {
  //   element: <PurchasedEventDetails />,
  //   requiredCapability: CAPABILITIES.platformAccess,
  //   path: Path.PurchasedEventDetails,
  //   name: 'Dashboard Details',
  // },
  {
    element: <CreateEvent />,
    requiredCapability: CAPABILITIES.platformAccess,
    path: Path.CreateEvent,
    name: "Create Event",
  },
  {
    element: <ViewPdf />,
    requiredCapability: CAPABILITIES.platformAccess,
    path: Path.ViewPdf,
    name: "View Pdf",
  },
  {
    element: <PreviewPdf />,
    requiredCapability: CAPABILITIES.platformAccess,
    path: Path.PreviewPdf,
    name: "View Pdf",
  },
  {
    element: <EditEventFrom />,
    requiredCapability: CAPABILITIES.platformAccess,
    path: Path.EditEvent,
    name: "Edit Event",
  },
  ...(SCORM_ENABLED
    ? [
        {
          element: <ScormPlayer />,
          requiredCapability: CAPABILITIES.platformAccess,
          path: Path.ScormPlayer,
          name: "SCORM Player",
        },
      ]
    : []),
  {
    element: <EditProfilePage />,
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.EditProfile,
    name: "Edit Details",
  },
  {
    element: <EditSubscription />,
    usesStripe: true,
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.EditSubscription,
    name: "Edit Details",
  },
  {
    element: (
      <RequireProfileLoaded>
        <EditGenderIdentity />
      </RequireProfileLoaded>
    ),
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.EditGenderIdentity,
    name: "Edit Gender Identity",
  },
  {
    element: (
      <RequireProfileLoaded>
        <EditEthnicity />
      </RequireProfileLoaded>
    ),
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.EditEthnicity,
    name: "Edit Ethnicity",
  },
  {
    // No RequireProfileLoaded: this editor loads its own state from
    // GET /v2/me/goals rather than reading the stored profile, so it does not
    // need the profile to be present and works on a direct link or a reload.
    element: <EditGoals />,
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.EditGoals,
    name: "Edit Goals",
  },
  {
    element: (
      <RequireProfileLoaded>
        <EditLGBTQDetails />
      </RequireProfileLoaded>
    ),
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.EditLGBTQDetails,
    name: "Edit LGBTQ",
  },
  {
    element: (
      <RequireProfileLoaded>
        <EditDisabilityStatus />
      </RequireProfileLoaded>
    ),
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.EditDisabilityStatus,
    name: "Edit Disability Status",
  },
  {
    element: (
      <RequireProfileLoaded>
        <EditLanguageSpoken />
      </RequireProfileLoaded>
    ),
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.EditLanguageSpoken,
    name: "Edit Language Spoken",
  },
  {
    element: (
      <RequireProfileLoaded>
        <EditEmploymentStatus />
      </RequireProfileLoaded>
    ),
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.EditEmploymentStatus,
    name: "Edit Employment Status",
  },
  {
    element: (
      <RequireProfileLoaded
        requires={profileSectionRequirements.sponsorProfile}
      >
        <EditLocationSponsor />
      </RequireProfileLoaded>
    ),
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.EditLocationSponsor,
    name: "Edit Location Sponsor",
  },
  {
    element: <PaymentDetails />,
    usesStripe: true,
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.PaymentDetails,
    name: "Payment Details",
  },
  {
    element: <TransactionsList />,
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.Transactions,
    name: "Past Purchases",
  },
  {
    element: <EditContentRetention />,
    usesStripe: true,
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.ContentRetention,
    name: "Content Retention",
  },
  {
    element: <ManageContentRetention />,
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.ManageContentRetention,
    name: "Manage Content Retention",
  },
  {
    element: <ChangePassword />,
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.ChangePassword,
    name: "Change Password",
  },
  {
    element: <HelpandSupport />,
    requiredCapability: CAPABILITIES.platformAccess,
    path: PathProfile.HelpSupport,
    name: "Help and Support",
  },
];

const PublicRoutes = [
  {
    element: <Signin />,
    path: Path.Signin,
    name: "SignIn",
    subRoute: [],
  },
  {
    element: <ForgotPassword />,
    path: Path.ForgotPassword,
    name: "Forgot Password",
    subRoute: [],
  },
  {
    element: <EnterSecurityCode />,
    path: Path.VerifyCode,
    name: "Verify Code",
    subRoute: [],
  },
  {
    element: <NewPassword />,
    path: Path.NewPassword,
    name: "New Password",
    subRoute: [],
  },
];

export { ProtectedRoutes, PublicRoutes };

export default Path;
